'use client'

import { useRouter, useSearchParams } from 'next/navigation'
import { useCallback } from 'react'

// Components
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

// Types
import type { Dictionary } from '@/types/global'
import type { Locale } from '@/i18n-config'
import { cn } from '@/lib/utils'

interface ProjectStatusFilterProps {
  lang: Locale
  dictionary: Dictionary
}

export function ProjectStatusFilter({
  lang,
  dictionary,
}: ProjectStatusFilterProps) {
  const router = useRouter()
  const searchParams = useSearchParams()

  const currentStatus = searchParams.get('status') || 'completed'

  const handleStatusChange = useCallback(
    (status: string) => {
      const params = new URLSearchParams(searchParams.toString())

      if (status === 'completed') {
        params.delete('status')
      } else {
        params.set('status', status)
      }

      const newUrl = `/${lang}/projects${params.toString() ? `?${params.toString()}` : ''}`
      router.push(newUrl)
    },
    [router, searchParams, lang]
  )

  return (
    <div className="flex items-center gap-3 -mb-[1px]">
      <button
        className={cn(
          '',
          currentStatus === 'all' && 'border-b-2 border-primary px-3'
        )}
        onClick={() => handleStatusChange('all')}
        disabled={currentStatus === 'all'}
      >
        {dictionary.projects['tag-status'].all}
      </button>
      <button
        className={cn(
          '',
          currentStatus === 'completed' && 'border-b-2 border-primary px-3'
        )}
        onClick={() => handleStatusChange('completed')}
        disabled={currentStatus === 'completed'}
      >
        {dictionary.projects['tag-status'].completed}
      </button>
      <button
        className={cn(
          '',
          currentStatus === 'ongoing' && 'border-b-2 border-primary px-3'
        )}
        onClick={() => handleStatusChange('ongoing')}
        disabled={currentStatus === 'ongoing'}
      >
        {dictionary.projects['tag-status'].ongoing}
      </button>
      {/* <span className="text-sm font-medium text-muted-foreground">
        {lang === 'tr' ? 'Durum:' : 'Status:'}
      </span>
      <Select value={currentStatus} onValueChange={handleStatusChange}>
        <SelectTrigger className="w-44">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">
            {dictionary.projects['tag-status'].all}
          </SelectItem>
          <SelectItem value="completed">
            {dictionary.projects['tag-status'].completed}
          </SelectItem>
          <SelectItem value="ongoing">
            {dictionary.projects['tag-status'].ongoing}
          </SelectItem>
        </SelectContent>
      </Select> */}
    </div>
  )
}
